import React, { useState } from "react";
import axios from "axios";
import { getApiUrl } from "../config/api";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/Components/ui/card";
import { Input } from "@/Components/ui/input";
import { Button } from "@/Components/ui/button";
import { Label } from "@/Components/ui/label";
import { Stack } from "@/Components/ui/layout";
import { Text } from "@/Components/ui/typography";
import { toast } from 'sonner';

function SignUpForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault(); 
    setErrorMessage(""); 

    if (!email || !password) {
      setErrorMessage("Please fill in all fields.");
      return;
    }

    try {
      const response = await axios.post(getApiUrl("/signup"), {
        email,
        password,
      });

      // Debug log removed — was leaking signup response (incl. token) to console.
      toast.success("Signup successful! Please login.");
      setTimeout(() => {
        window.location.href = "/login";
      }, 1500);
    } catch (error) {
      console.error("Signup error:", error.response?.data || error.message);
      setErrorMessage(
        error.response?.data?.message || "An error occurred during signup."
      );
    }
  };

  return (
    <Card className="rounded-[18px] shadow-md border-[5px] border-muted p-5 flex items-center justify-center max-w-[510px] ml-[70px]">
      <CardContent className="p-0 w-full max-w-[450px]">
        <form onSubmit={handleSubmit} className="w-full max-w-[495px]">
          <CardHeader className="p-0 pb-0">
            <CardTitle className="text-foreground font-poppins m-0">Sign Up</CardTitle>
            <CardDescription className="text-muted-foreground font-poppins mt-2.5 mb-10">
              It's fast and easy
            </CardDescription>
          </CardHeader>
          
          {errorMessage && (
            <Text size="sm" variant="destructive" className="mb-4">
              {errorMessage}
            </Text>
          )}

          <Stack spacing="md" className="mr-5 mb-6">
            <Stack spacing="sm">
              <Label htmlFor="email" className="sr-only">Email</Label>
              <Input
                type="email"
                id="gmail"
                placeholder="Email*"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="rounded-[18px] px-4 py-5 text-lg border-foreground"
              />
            </Stack>

            <Stack spacing="sm">
              <Label htmlFor="password" className="sr-only">Password</Label>
              <div className="relative">
                <Input
                  type={passwordVisible ? "text" : "password"}
                  id="password"
                  placeholder="Password*"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="rounded-[18px] px-4 py-5 text-lg border-2 border-muted-foreground/50 pr-12"
                />
                <img
                  src={
                    !passwordVisible
                      ? "https://cdn-icons-png.flaticon.com/128/709/709612.png"
                      : "https://cdn-icons-png.flaticon.com/128/2767/2767146.png"
                  }
                  alt="Toggle password visibility"
                  className="absolute right-2.5 top-1/2 -translate-y-1/2 w-[25px] h-[25px] cursor-pointer mt-2"
                  role="button"
                  tabIndex={0}
                  onClick={() => setPasswordVisible(!passwordVisible)}
                />
              </div>
            </Stack>
          </Stack>

          <Stack spacing="sm">
            <Button 
              type="submit" 
              variant="default"
              className="w-full max-w-[200px] mt-11 text-center font-poppins py-3 px-3 bg-gradient-to-r from-primary via-[#50c598] to-primary hover:from-[#50c598] hover:via-primary hover:to-[#50c598]"
            >
              Get Started
            </Button>
            <Text size="sm" className="text-primary font-poppins">
              Already have an account? <a href="/login" className="underline">Login</a>
            </Text>
          </Stack>
        </form>
      </CardContent>
    </Card>
  );
}

export default SignUpForm;
